<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'
import { Spinner } from '#ui-kit/ui/spinner'

const props = defineProps<{
  class?: HTMLAttributes['class']
  loading?: boolean
}>()
</script>

<template>
  <div data-slot="card-content" :class="cn('px-5 py-4', props.class)">
    <div v-if="loading" class="flex min-h-55 items-center justify-center">
      <Spinner size="sm" />
    </div>
    <slot v-else />
  </div>
</template>
